import React from "react";
import AaIcon from "./AaIcon";
import DefaultProductIcon from "./DefaultProductIcon";
import JaIcon from "./JaIcon";
import OdIcon from "./OdIcon";
import RerIcon from "./RerIcon";
import RmIcon from "./RmIcon";
import TsBatchIcon from "./TsBatchIcon";
import TsIcon from "./TsIcon";
// import TvIcon from "./TvIcon";
// tv icon stands for traffic volumes which will be introduced as a product soon, but now it's commented out since it has a conflict with
// existing traffic viewer which will be decomissioned soon.
// Probaly the shortcut TV should be changed to something else like HTV (historical traffic volumes) TODO
var productIconMapping = {
    ctm: RmIcon,
    od: OdIcon,
    rer: RerIcon,
    ts: TsIcon,
    tsb: TsBatchIcon,
    ja: JaIcon,
    aa: AaIcon,
    // tv: TvIcon,
};
export function getProductIcon(productId) {
    var _a;
    if (productIconMapping.hasOwnProperty(productId)) {
        return productIconMapping[productId];
    }
    var masterId = Object.keys(productIconMapping).find(function (id) {
        return productId.startsWith(id);
    });
    return (_a = productIconMapping[masterId !== null && masterId !== void 0 ? masterId : ""]) !== null && _a !== void 0 ? _a : DefaultProductIcon;
}
export function renderProductIcon(productId) {
    var ProductIcon = getProductIcon(productId);
    return React.createElement(ProductIcon, null);
}
//# sourceMappingURL=getProductIcon.js.map